import { AHText, AHTextFonts, Box } from "arkh";
import React from "react";
import { useIntlTokens } from "./mobile/useIntlTokens";

// TODO: Translate
export const TaskSelectListEmpty = (props: { routineTitle: string }) => {
  const intl_tokens = useIntlTokens();
  return (
    <Box cornerRadius="large" space="medium" color="surface">
      <AHText
        type="title-small"
        font={AHTextFonts.REGULAR}
        style={{ textAlign: "center" }}
      >
        {intl_tokens.Checklist}{" "}
        <AHText type="title-small" color="primary">
          {props.routineTitle}
        </AHText>{" "}
        innehåller inga valbara kontrollpunkter
      </AHText>
    </Box>
  );
};
